module.exports = __webpack_public_path__ + "static/img/taobao.219b470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/taobao.png
// module id = eEdM
// module chunks = 1